import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import {
  genElNumber,
  genElText,
  genElTextArea,
} from "../components/utils/EditorDialogElementGenerator";
import GoogleMapsPicker from "../components/GoogleMapsPicker";

const editTitle = "Edit Toko";
const addTitle = "Tambah Toko";

const EditTokoDialog = (props) => {
  const {
    visible,
    onHide,
    onConfirm,
    loading,
    title,
    data,
    setData,
    addNewMode,
    error,
    setError,
  } = props;

  /**
   * Validates the form data.
   *
   * @returns {boolean} - Returns true if the data is valid, otherwise false.
   * @returns {object} - Returns an object containing the error messages, format { field: message}.
   */
  const validate = () => {
    let valid = true;
    let newEror = {};

    if (!valid) setError(newEror);

    return valid;
  };

  // handle UI event section

  /**
   * Generate Dialog Form Element
   *
   * various function to generate
   *
   * genElText({ field, name, data, setData, disabled, autoFocus, error })
   * genElTextPassword({ field, name, data, setData, disabled, autoFocus, error })
   * genElTextDropdown({ field, name, data, setData, options, disabled, autoFocus, error, optionLabel = "name" })
   * genElNumber({ field, name, data, setData, min_fraction_digits, max_fraction_digits, min, max, disabled, autoFocus, error })
   * genElNumberDropdown({ field, name, data, setData, options, disabled, autoFocus, error, optionLabel = "name" })
   * genElBoolean({ field, name, data, setData, labelTrue = "Ya", labelFalse = "Tidak", disabled, autoFocus, error })
   * genElDate({ field, name, data, setData, primeFormat, min, max, showTime, time, month, year, disabled, autoFocus, error })
   * genElObject({ field, name, value, onClick, selectorGenerator, disabled, autoFocus, error })
   */

  const elNamaToko = genElText({
    field: "nama_toko",
    name: "Nama Toko",
    data,
    setData,
    error,
  });
  const elNamaPemilik = genElText({
    field: "nama_pemilik",
    name: "Nama Pemilik",
    data,
    setData,
    error,
  });
  const elTelepon = genElText({
    field: "telepon",
    name: "Telepon Toko",
    data,
    setData,
    error,
  });
  const elJamBuka = genElText({
    field: "jam_buka",
    name: "Jam Buka",
    data,
    setData,
    error,
  });
  const elLatitude = genElText({
    field: "latitude",
    name: "Latitude",
    data,
    setData,
    error,
  });
  const elLongitude = genElText({
    field: "latitude",
    name: "Latitude",
    data,
    setData,
    error,
  });
  const elAlamat = genElTextArea({
    field: "alamat",
    name: "Alamat",
    data,
    setData,
    error,
  });

  const dialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={props.onHide}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        onClick={(e) => {
          const valid = validate();
          if (valid) {
            onConfirm(data);
          }
        }}
      />
    </React.Fragment>
  );

  const handleGetCoordinate = ({ latitude, longitude, address }) => {
    const newData = {...data};
    
    newData.latitude = latitude;
    newData.longitude = longitude;
    newData.alamat = address;

    setData(newData);
  }

  return (
    <Dialog
      visible={visible}
      style={{ width: "55rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={addNewMode ? addTitle : editTitle}
      modal
      className={`p-fluid`}
      footer={dialogFooter}
      onHide={onHide}
    >
      <div className="col-start-center relative h-100">
        <div className={`row-start-start w-100 gap-3`}>
          <div className="col-start-start w-100 gap-3">
            {elNamaToko}
            {elNamaPemilik}
            {elTelepon}
            {elJamBuka}
            {elLatitude}
            {elLongitude}
            {/* {elAlamat} */}
            <GoogleMapsPicker
              longitude={data.longitude}
              latitude={data.latitude}
              address={data.alamat}
              handleGetCoordinate={handleGetCoordinate}
            />
          </div>
        </div>
        {loading && (
          <div
            className={`col-center-center w-100  gap-2 absolute z-100 h-100 bg-black/20 rounded `}
          >
            <ProgressSpinner />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default EditTokoDialog;
